import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';
import { EventDetail } from './event-list.service';

ng.module('selfReg').run(eventSelectConfig);

eventSelectConfig.$inject = ['$transitions'];
function eventSelectConfig($transitions:uir.TransitionService) {
   $transitions.onFinish({ to: 'shell.events'}, bypassEventSelect);

   function bypassEventSelect(trans:uir.Transition) {
      let events = trans.injector().get<EventDetail[]>('events');

      if (events && events.length == 1) {
         let params = ng.extend({eventId: events[0].id}, trans.params())
         return trans.router.stateService.target('shell.events.register', params);
      }
   }
}
